import Vue from 'vue'
import Vuex from 'vuex'
import {
  getBanners,
  getPartners,
  getNewsList,
  getNewsReadCounts,
  getNewsReadCount,
  incrementNewsRead,
  getIndustryList,
  getIndustryReadCounts,
  incrementIndustryRead
} from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    bannersList: [],
    partnersList: [],
    newsList: [],
    readCounts: {},
    industryList: [],
    industryReadCounts: {}
  },
  mutations: {
    setBannersList(state, list) {
      state.bannersList = Array.isArray(list) ? list : []
    },
    setPartnersList(state, list) {
      state.partnersList = Array.isArray(list) ? list : []
    },
    setNewsList(state, list) {
      state.newsList = Array.isArray(list) ? list : []
    },
    setReadCount(state, { id, count }) {
      Vue.set(state.readCounts, String(id), count)
    },
    setReadCounts(state, counts) {
      if (counts && typeof counts === 'object') {
        state.readCounts = { ...counts }
      }
    },
    setIndustryList(state, list) {
      state.industryList = Array.isArray(list) ? list : []
    },
    setIndustryReadCount(state, { id, count }) {
      Vue.set(state.industryReadCounts, String(id), count)
    },
    setIndustryReadCounts(state, counts) {
      if (counts && typeof counts === 'object') {
        state.industryReadCounts = { ...counts }
      }
    }
  },
  actions: {
    async fetchBanners({ commit }) {
      try {
        const { data } = await getBanners()
        commit('setBannersList', data)
      } catch (e) {
        commit('setBannersList', [])
      }
    },
    async fetchPartners({ commit }) {
      try {
        const { data } = await getPartners()
        commit('setPartnersList', data)
      } catch (e) {
        commit('setPartnersList', [])
      }
    },
    async fetchNews({ commit }) {
      try {
        const [listRes, countsRes] = await Promise.all([getNewsList(), getNewsReadCounts()])
        commit('setNewsList', listRes.data)
        commit('setReadCounts', countsRes.data)
      } catch (e) {
        commit('setNewsList', [])
      }
    },
    async fetchReadCount({ commit }, id) {
      try {
        const { data } = await getNewsReadCount(id)
        commit('setReadCount', { id: data.id, count: data.count })
      } catch (_) { /* ignore */ }
    },
    async incrementReadCount({ commit }, id) {
      try {
        const { data } = await incrementNewsRead(id)
        commit('setReadCount', { id: data.id, count: data.count })
      } catch (_) { /* ignore */ }
    },
    async fetchIndustry({ commit }) {
      try {
        const [listRes, countsRes] = await Promise.all([getIndustryList(), getIndustryReadCounts()])
        commit('setIndustryList', listRes.data)
        commit('setIndustryReadCounts', countsRes.data)
      } catch (e) {
        commit('setIndustryList', [])
      }
    },
    async incrementIndustryReadCount({ commit }, id) {
      try {
        const { data } = await incrementIndustryRead(id)
        commit('setIndustryReadCount', { id: data.id, count: data.count })
      } catch (_) { /* ignore */ }
    }
  },
  getters: {
    getBannersList: state => [...state.bannersList].reverse(),
    getBannerById: state => id => state.bannersList.find(b => b.id === Number(id)) || null,
    getPartnersList: state => [...state.partnersList].reverse(),
    getNewsList: state => [...state.newsList].reverse(),
    getNewsById: state => id => state.newsList.find(n => n.id === Number(id)) || null,
    getReadCount: state => id => Number(state.readCounts[String(id)]) || 0,
    getIndustryList: state => [...state.industryList].reverse(),
    getIndustryById: state => id => state.industryList.find(n => n.id === Number(id)) || null,
    getIndustryReadCount: state => id => Number(state.industryReadCounts[String(id)]) || 0
  }
})
